import {
  getWhatsappReachoutStatusClassKey,
  getWhatsappReachoutStatusLabel,
} from "@features/PricingProject/lib/whatsappReachoutStatus";
import { WhatsappReachoutStatus } from "@shared/lib/types/briefInfluencerV2";
import { Button, Tag, Tooltip } from "@shared/ui";
import { ExternalLink } from "lucide-react";
import styles from "./PricingProject.module.scss";

type WhatsappReachoutStatusBadgeProps = {
  status?: WhatsappReachoutStatus;
  failedReason?: string;
  deeplinkUrl?: string;
};

export function WhatsappReachoutStatusBadge({
  status,
  failedReason,
  deeplinkUrl,
}: WhatsappReachoutStatusBadgeProps) {
  const classKey = getWhatsappReachoutStatusClassKey(status);
  const label = getWhatsappReachoutStatusLabel(status);
  const trimmedDeeplink = deeplinkUrl?.trim();
  const showFailedTooltip =
    status === WhatsappReachoutStatus.Failed && Boolean(failedReason?.trim());

  const tag = (
    <Tag
      bordered
      className={`${styles.reachoutStatusTag} ${styles[`reachoutStatusTag_${classKey}`]}`}
    >
      {label}
    </Tag>
  );

  const statusTag = showFailedTooltip ? (
    <Tooltip title={failedReason}>{tag}</Tooltip>
  ) : (
    tag
  );

  const openDeeplink = () => {
    if (!trimmedDeeplink) {
      return;
    }
    window.open(trimmedDeeplink, "_blank", "noopener,noreferrer");
  };

  return (
    <div className={styles.reachoutStatusCell}>
      {statusTag}
      {trimmedDeeplink ? (
        <Tooltip title="Open link in new tab">
          <Button
            type="link"
            size="small"
            className={styles.reachoutDeeplinkBtn}
            icon={<ExternalLink size={14} />}
            onClick={openDeeplink}
            aria-label="Open link in new tab"
          />
        </Tooltip>
      ) : null}
    </div>
  );
}
